import { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCurrencies() {
      try {
        setLoading(true);

        const res = await fetch(`/api/currencies?pagination[pageSize]=500`);
        const json = await res.json();

        const list = json.data.map((item) => ({
          id: item.id,
          code: item.code,
          name: item.name,
          symbol: item.symbol,
          rate: item.rate,
          decimal_places: item.decimal_places
        }));

        setCurrencies(list);

        // 🔥 LOCALSTORAGE-BÓL PRÓBÁLUNK BETÖLTENI — CSAK A CODE VAN ELMENTVE
        let savedCode = null;
        if (typeof window !== "undefined") {
          savedCode = localStorage.getItem("user_currency_code");
        }

        // ha van mentett kód és létezik a friss listában → azt állítjuk be
        if (savedCode) {
          const matched = list.find(c => c.code === savedCode);
          if (matched) {
            setCurrency(matched);
            return; // fontos: ne fusson tovább a fallback
          }
        }

        // 🔥 fallback: HUF, ha létezik
        const huf = list.find(c => c.code === "HUF");
        if (huf) {
          setCurrency(huf);
          return;
        }

        // 🔥 fallback: első currency
        setCurrency(list[0]);


      } catch (err) {
        console.error("Currency load error:", err);
      } finally {
        setLoading(false);
      }
    }

    loadCurrencies();
  }, []);

  // 🔥 Kerekítés és formázás a decimal_places alapján
  function formatCurrency(value) {
    if (!currency) return value;

    const decimals = currency.decimal_places ?? 0;

    let converted = value;

    // HUF → más valuta
    if (currency.code !== "HUF") {
      converted = value * currency.rate;
    }

    // 🔥 KEREKÍTÉS
    const rounded = converted.toFixed(decimals);

    // 🔥 EZRES TAGOLÁS manuálisan
    const parts = rounded.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return parts.join(",");
  }

  return (
    <CurrencyContext.Provider value={{ currencies, currency, setCurrency, loading, formatCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
